export class delegationsdto {
    unavailableusersid: string | undefined;
    usercreated: string | undefined;
    datecreated: string | undefined;
    userupdated: string | undefined;
    dateupdated: string | undefined;
    deletedyn: boolean | false;
    awayuser: string | undefined;
    awayuserdisplayname: string | undefined;
    awayfrom: string | undefined;
    awayto: string | undefined;
    delegateyn: boolean | false;
    delegateuser: string | undefined;
    delegateuserdisplayname: string | undefined;
}